import * as React from "react";
import * as ReactDOM from "react-dom";
import { OptionalLink } from "../optionalLink";

interface IProperties
{
    /**
     * Anzeige Text.
     */
    text?: string,

    /**
     * Link (react-router).
     */
    linkTo?: string | {},

    /**
     * Angabe, ob das Item abgeschaltet ist.
     */
    isDisabled?: boolean,

    /**
     * Angabe, ob das Item selektiert ist.
     */
    isSelected?: boolean,

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (e?: MouseEvent) => void
}

export class NavigationItem extends React.Component<IProperties>
{
    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        this.props.onClick && this.props.onClick(e.nativeEvent);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { text, linkTo, isDisabled, isSelected, onClick } = this.props;
        const content: JSX.Element[] = [];
        const classNames: string[] = ["nav_item"];

        if (isDisabled)
            classNames.push("nav_item--disabled");

        if (isSelected)
            classNames.push("nav_item--selected");

        return (
            <OptionalLink
                className={classNames.join(" ")}
                to={linkTo}
                onClick={this.onClick}>
                <span className="navigation_item_text">{text}</span>
            </OptionalLink>
        );
    }
}